import React from 'react';
import { useLms } from '../../context/LmsContext';
import { Card, DataTable, PageHeader, StatusBadge } from '../../components/ui';
import { byId, fullName, getCourse } from '../../utils/lmsSelectors';
import { downloadCertificatePdf } from '../../utils/certificatePdf';

export default function AdminCertificates() {
  const { data, currentUser, revokeCertificate } = useLms();
  const rows = data.certificates.map((certificate) => ({
    ...certificate,
    learner: fullName(byId(data.users, certificate.userId)),
    course: getCourse(data, certificate.courseId)?.title,
    issued: new Date(certificate.issuedAt).toLocaleDateString()
  }));

  return (
    <>
      <PageHeader title="Certificate register" eyebrow="Admin" description="Download, revoke, and reissue course completion certificates." />
      <Card>
        <DataTable
          rows={rows}
          columns={[
            { key: 'certificateNumber', label: 'Certificate #' },
            { key: 'learner', label: 'Learner' },
            { key: 'course', label: 'Course' },
            { key: 'issued', label: 'Issued' },
            { key: 'status', label: 'Status', render: (row) => <StatusBadge status={row.status} /> },
            {
              key: 'actions',
              label: 'Actions',
              render: (row) => (
                <div className="button-row compact">
                  <button className="button button-secondary" disabled={row.status !== 'active'} onClick={() => downloadCertificatePdf(row, data)}>Download PDF</button>
                  <button className="button button-ghost" onClick={() => revokeCertificate(row.id, currentUser.id)}>Revoke</button>
                </div>
              )
            }
          ]}
          emptyMessage="No certificates have been generated yet."
        />
      </Card>
    </>
  );
}
